import { render } from "./AccountMenuComponent.vue?vue&type=template&id=c5b80ff4"
import script from "./AccountMenuComponent.vue?vue&type=script&lang=js"
export * from "./AccountMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__